import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';

// Import the existing collaboration page for Internal Feedback
import CollaborationPage from '../collaboration/CollaborationPage';
import BrandApprovalsPage from './BrandApprovalsPage';

/**
 * ApprovalsLayout - Parent layout for the Approvals & Feedback module
 * Routes:
 *   /approvals/internal - Internal Feedback (team reviews)
 *   /approvals/brand - Brand Approval (client reviews)
 */
const ApprovalsLayout: React.FC = () => {
    return (
        <Routes>
            {/* Default redirect to internal */}
            <Route path="" element={<Navigate to="internal" replace />} />

            {/* Internal Feedback - Reuses existing CollaborationPage */}
            <Route path="internal/*" element={<CollaborationPage />} />

            {/* Brand Approval - New page */}
            <Route path="brand/*" element={<BrandApprovalsPage />} />
        </Routes>
    );
};

export default ApprovalsLayout;
